<template>
  <button
    type="button"
    class="grid-view__row-more"
    :aria-label="$t('gridViewRowExpandButton.expandRow')"
    @click="onClick"
  >
    <i class="baserow-icon-enlarge-row"></i>
  </button>
</template>
<script>
export default {
  name: 'GridViewRowExpandButton',
  emits: ['edit-modal'],
  methods: {
    onClick() {
      this.$emit('edit-modal')
    },
  },
}
</script>
